import React from "react";
import { RightSidebar, RightSidebarContent } from "../RightSidebar";
import styles from "./ApplicantDetailSidebar.module.scss";
import { useApplicantDetails } from "./hooks";
import { ApplicantDetailSidebarHeader } from "./ApplicantDetailSidebarHeader";
import { ApplicantDetails } from "./ApplicantDetail";
import { ApplicantDetailSidebarFooter } from "./ApplicantDetailSidebarFooter";
import { useApplicantActions, useApplicantHelpers } from "./helper";
import { Spinner } from "@blueprintjs/core";

export default function ApplicantDetailSidebar({
  applicantId,
  opportunityId,
  isApplicantDetailsOpen,
  onDismissSidebar,
  onApplicationAction,
  applicantType,
  isReadOnly
}) {
  const { applicant, firstApplicationEvent } = useApplicantDetails({
    applicantId,
    opportunityId
  });

  const { onApprove, onReject } = useApplicantActions({
    applicant,
    onApplicationAction
  });

  const {
    socialIdentites,
    getSocialUrlByName,
    isSocialConnected
  } = useApplicantHelpers({ applicant });

  return (
    <RightSidebar sidebarIsOpen={isApplicantDetailsOpen}>
      {!applicant && <Spinner className={styles.spinner} />}
      {applicant && (
        <>
          <ApplicantDetailSidebarHeader
            applicant={applicant}
            onDismissSidebar={onDismissSidebar}
          />

          <RightSidebarContent className={styles.applicantDetailContainer}>
            <ApplicantDetails
              applicant={applicant}
              firstApplicationEvent={firstApplicationEvent}
              getSocialUrlByName={getSocialUrlByName}
              isSocialConnected={isSocialConnected}
              socialIdentites={socialIdentites}
            />
          </RightSidebarContent>
          <ApplicantDetailSidebarFooter
            type={applicantType}
            onApprove={onApprove}
            onReject={onReject}
            onDismissSidebar={onDismissSidebar}
            isReadOnly={isReadOnly}
          />
        </>
      )}
    </RightSidebar>
  );
}
